import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import useAuth from "../hooks/auth";

const PrivateRoute = ({ role, ...restProps }) => {
  const { deleteAuth, isAuthenticated } = useAuth();

  useEffect(() => {
    !isAuthenticated && deleteAuth();
  }, [isAuthenticated]);

  return isAuthenticated ? <Route {...restProps} /> : <Redirect to="/" />;
};

export default PrivateRoute;
